import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ExploreProvider } from './context/ExploreContext';
import ExploreIntroPage from './pages/ExploreIntroPage';
import ExploreDiscoveryPage from './pages/ExploreDiscoveryPage';
import ExploreNeoPage from './pages/ExploreNeoPage';
import ExploreMorpheusPage from './pages/ExploreMorpheusPage';
import ExploreLinkPage from './pages/ExploreLinkPage';
import ExploreBuildPage from './pages/ExploreBuildPage';
import ExploreLaunchPage from './pages/ExploreLaunchPage';

export default function ExploreApp() {
  return (
    <ExploreProvider>
      <Routes>
        <Route index element={<Navigate to="start" replace />} />
        <Route path="start" element={<ExploreIntroPage />} />
        <Route path="discover" element={<ExploreDiscoveryPage />} />
        <Route path="neo" element={<ExploreNeoPage />} />
        <Route path="morpheus" element={<ExploreMorpheusPage />} />
        <Route path="link" element={<ExploreLinkPage />} />
        <Route path="build" element={<ExploreBuildPage />} />
        <Route path="launch" element={<ExploreLaunchPage />} />
        <Route path="*" element={<Navigate to="start" replace />} />
      </Routes>
    </ExploreProvider>
  );
}
